import styled from 'styled-components'
import { Box, Typography } from 'src/components'
import { motion } from 'framer-motion'
import header from 'src/assets/Testimonials/headerbox_11zon.avif'
import body from 'src/assets/Testimonials/message_11zon.avif'

export const OverCard = styled(motion(Box))`
    cursor: pointer;
    border-radius: 30px;
    .flip-card {
        width: 283px;
        height: 307.41px;
        perspective: 2000px;
    }
    .flip-card-inner {
        position: relative;
        width: 100%;
        height: 100%;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
        border-radius: 28px;
        transition: all 550ms cubic-bezier(0.1, 0.22, 0.8, 1.13);
        transform-style: preserve-3d;
    }

    .flip-card:hover .flip-card-inner {
        transform: rotateY(-180deg);
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        .flip-card {
            width: 288.82px;
            height: 312.91px;
            perspective: 2000px;
        }
        .flip-card-inner {
            position: relative;
            width: 100%;
            height: 100%;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
            border-radius: 28px;
            transition: all 550ms cubic-bezier(0.1, 0.22, 0.8, 1.13);
            transform-style: preserve-3d;
        }

        .flip-card:hover .flip-card-inner {
            transform: rotateY(-180deg);
        }
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        .flip-card {
            width: 344px;
            height: 370px;
            perspective: 2000px;
        }
        .flip-card-inner {
            position: relative;
            width: 100%;
            height: 100%;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
            border-radius: 28px;
            transition: all 550ms cubic-bezier(0.1, 0.22, 0.8, 1.13);
            transform-style: preserve-3d;
        }

        .flip-card:hover .flip-card-inner {
            transform: rotateY(-180deg);
        }
    }
`
export const FlipCard = styled(Box)``

export const Card = styled(Box)``

export const BackSide = styled(Box)`
    position: absolute;
    width: 100%;
    height: 100%;
    backface-visibility: hidden;
    border-radius: 30px;
    background: ${({ theme }) => theme.colors.white};
    transform: rotateY(180deg);
`

export const HeaderBox = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: url(${header}) no-repeat center/cover;
    flex-direction: column;
    border-radius: 26px 26px 0 0;
    height: 89.53px;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        flex-direction: column;
        height: 99.53px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        flex-direction: column;

        height: 106px;
        background-size: contain;
    }
`

export const TitleTypography = styled(Typography)`
    font-family: inherit;
    font-style: italic;
    line-height: 17px;
    padding-top: 15px;
    color: ${({ theme }) => theme.colors.white};
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        line-height: 18px;
        padding-top: 16px;
    }
`
export const ImageContent = styled(Box)`
    width: 85px;
    height: 85px;
    filter: drop-shadow(0px 0px 14px rgba(0, 0, 0, 0.1));
    border-radius: 42.5px;
    object-fit: contain;
`
export const ImageSection = styled.img`
    width: 75px;
    height: 75px;
    filter: drop-shadow(0px 0px 14px rgba(0, 0, 0, 0.1));
    border-radius: 42.5px;
    object-fit: contain;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 85px;
        height: 85px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 85px;
        height: 85px;
    }
`
export const FrontSide = styled(Box)<{ backgroundImage: string }>`
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 30px;
    backface-visibility: hidden;
    background: url(${(props) => props.backgroundImage}) no-repeat center/cover;
`

export const ContentSection = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: center;
`
export const ContentMessage = styled(Box)`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: url(${body}) no-repeat center/cover;
    width: 262px;
    height: 161px;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 279px;
        height: 161px;
    }
`
export const ContentQuotes = styled(Box)`
    width: 15px;
    height: 13px;
    position: absolute;
    top: 8px;
    left: 13px;
`
export const QuotesClose = styled(Box)`
    width: 15px;
    height: 13px;
    position: absolute;
    bottom: 42px;
    right: 12px;
`

export const QuotesEnt = styled.img`
    width: 15px;
    height: 13px;
    object-fit: contain;
`
export const ContentTestimonial = styled(Typography)`
    font-family: inherit;
    font-style: normal;
    color: ${({ theme }) => theme.colors.dark};
    text-align: center;
    width: 224px;
    height: 90px;
    margin-top: 25px;
    line-height: 15px;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        line-height: 15px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 223px;
        margin-top: 21px;
        line-height: 15px;
    }
`
